/** @format */


export default {
  namespaced:true,
  state: {
    templateId: 0
  },
  mutations: {
    submitResumeTemplateId(state, val) {
      state.templateId = val;
    },
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/module/resume.js